var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasMessage)?_c('div',{staticClass:"text-sm mt-1",class:_vm.hintType},[_vm._t("default",function(){return [_vm._v("\n        "+_vm._s(_vm.hintMessage)+"\n    ")]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }